






























import { Component, Prop, Vue } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import * as graph from '@shared/types/graphql'
import icoLookup from '@/utilities/ico-lookup'
import A from '@/utilities/alpha'
import S3Assets from '@/api/S3Assets'

@Component({
})
export default class ClientUploadInput extends Vue {
  @Prop({ required: true }) upload!: graph.Prototype
  errors: Record<string, string[]> = {}

  mounted () {
    this.errors[this.upload.id] = []
    this.validateUrl()
    this.validateTitle()
    this.$emit('fieldsValidated', this.errors)
  }

  get isDisabled () {
    return S3Assets.urlIsFloopAsset(this.upload.url ?? '')
  }

  get icoLookup () {
    return icoLookup
  }

  onKeyUp (event: KeyboardEvent, id: string, field: string) {
    if (event.key === 'Tab') return

    if (field === 'url') {
      this.validateUrl()
    }

    if (field === 'title') {
      this.validateTitle()
    }

    this.$emit('editUpload', this.upload)
    this.$emit('fieldsValidated', this.errors)
  }

  onBlur (event: FocusEvent, upload: graph.Prototype) {
    // Trim all strings on blur
    for (const key in upload) {
      const typedKey = key as keyof graph.Prototype
      if (typeof upload[typedKey] === 'string') {
        (upload[typedKey] as string) = (upload[typedKey] as string).trim()
      }
    }

    this.$emit('editUpload', this.upload)
    this.$emit('fieldsValidated', this.errors)
  }

  validateUrl () {
    const invalidUrlPos = this.errors[this.upload.id]?.indexOf(db.ValidationErrors.InvalidUrlError)
    if (~invalidUrlPos) this.errors[this.upload.id].splice(invalidUrlPos, 1)

    const missingUrlPos = this.errors[this.upload.id]?.indexOf(db.ValidationErrors.MissingUrlError)
    if (~missingUrlPos) this.errors[this.upload.id].splice(missingUrlPos, 1)

    if (!this.upload.url?.trim()) {
      this.errors[this.upload.id].push(db.ValidationErrors.MissingUrlError)
    }
    if (this.upload.url?.trim() && !A.isValidUrl(this.upload.url)) {
      this.errors[this.upload.id].push(db.ValidationErrors.InvalidUrlError)
    }
  }

  validateTitle () {
    const missingTitlePos = this.errors[this.upload.id]?.indexOf(db.ValidationErrors.MissingTitleError)
    if (~missingTitlePos) this.errors[this.upload.id].splice(missingTitlePos, 1)

    if (!this.upload.title.trim()) {
      this.errors[this.upload.id].push(db.ValidationErrors.MissingTitleError)
    }
  }
}
